export enum LoadingState {
    idle = 'idle',
    loading = 'loading',
    finished = 'finished',
    failed = 'failed',
}
